import type { RouteProps } from '../../router/routers';

export const buildNavigation = (
    routes: RouteProps[],
    hasAccess: (code?: string, path?: string | null) => boolean
) => routes.filter(group => group.showInMenu).map(group => ({
    name: group.name,
    icon: group.icon,
    items: (group.children || [])
        .filter(item => item.showInMenu && item.path && hasAccess(item.permission, item.path))
        .map(item => ({path: item.path as string, name: item.name, icon: item.icon}))
})).filter(group => group.items.length > 0);
